export { InsightsContainer } from './InsightsContainer';
